import React from 'react'

export default function QuestionCanvas({children}) {
  return (
    <div className="question-canvas relative">
      {children}
    </div>
  )
}
